import * as types from '../constants/patterns';

const initialState = {
    summary: {
        patternCount: 0,
        clusteredPct: 0.0,
        topRecoveryDollars: 0.0,
        outlierCount: 0,
        totalClaims: 0,
        asOf: null
    },
    list: [],
    details: {}, // Keyed by patternId
    loading: {
        summary: false,
        list: false,
        details: false
    },
    error: null
};

const patternsReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case types.FETCH_PATTERN_SUMMARY_REQUEST:
            return {
                ...state,
                loading: { ...state.loading, summary: true },
                error: null
            };
        case types.FETCH_PATTERN_SUMMARY_SUCCESS:
            return {
                ...state,
                summary: action.payload,
                loading: { ...state.loading, summary: false }
            };
        case types.FETCH_PATTERN_SUMMARY_FAILURE:
            return {
                ...state,
                loading: { ...state.loading, summary: false },
                error: action.payload
            };

        case types.FETCH_PATTERNS_REQUEST:
            return {
                ...state,
                loading: { ...state.loading, list: true },
                error: null
            };
        case types.FETCH_PATTERNS_SUCCESS:
            return {
                ...state,
                list: action.payload,
                loading: { ...state.loading, list: false }
            };
        case types.FETCH_PATTERNS_FAILURE:
            return {
                ...state,
                loading: { ...state.loading, list: false },
                error: action.payload
            };

        case types.FETCH_PATTERN_CLAIMS_REQUEST:
            return {
                ...state,
                loading: { ...state.loading, details: true },
                error: null
            };
        case types.FETCH_PATTERN_CLAIMS_SUCCESS:
            return {
                ...state,
                details: {
                    ...state.details,
                    [action.payload.patternId]: action.payload
                },
                loading: { ...state.loading, details: false }
            };
        case types.FETCH_PATTERN_CLAIMS_FAILURE:
            return {
                ...state,
                loading: { ...state.loading, details: false },
                error: action.payload
            };

        default:
            return state;
    }
};

export default patternsReducer;
